// @ts-nocheck
export const localeCodes =  [
  "en-int",
  "en-emea",
  "en-jp",
  "en-tw",
  "en-kr",
  "en-americas",
  "en-asia-pacific",
  "ja-jp",
  "zh-cn",
  "zh-tw"
]
export const localeLoaders = {
  "en-int": [
    {
      key: "locale_en_45int_46json_8591ae0d",
      load: () => import("#nuxt-i18n/8591ae0d" /* webpackChunkName: "locale_en_45int_46json_8591ae0d" */),
      cache: true
    }
  ],
  "en-emea": [
    {
      key: "locale_en_45emea_46json_a498b7ee",
      load: () => import("#nuxt-i18n/a498b7ee" /* webpackChunkName: "locale_en_45emea_46json_a498b7ee" */),
      cache: true
    }
  ],
  "en-jp": [
    {
      key: "locale_en_45jp_46json_2ae6e5dc",
      load: () => import("#nuxt-i18n/2ae6e5dc" /* webpackChunkName: "locale_en_45jp_46json_2ae6e5dc" */),
      cache: true
    }
  ],
  "en-tw": [
    {
      key: "locale_en_45tw_46json_05fffeaa",
      load: () => import("#nuxt-i18n/05fffeaa" /* webpackChunkName: "locale_en_45tw_46json_05fffeaa" */),
      cache: true
    }
  ],
  "en-kr": [
    {
      key: "locale_en_45kr_46json_4a538bd0",
      load: () => import("#nuxt-i18n/4a538bd0" /* webpackChunkName: "locale_en_45kr_46json_4a538bd0" */),
      cache: true
    }
  ],
  "en-americas": [
    {
      key: "locale_en_45americas_46json_9a0f5a94",
      load: () => import("#nuxt-i18n/9a0f5a94" /* webpackChunkName: "locale_en_45americas_46json_9a0f5a94" */),
      cache: true
    }
  ],
  "en-asia-pacific": [
    {
      key: "locale_en_45asia_45pacific_46json_34dad782",
      load: () => import("#nuxt-i18n/34dad782" /* webpackChunkName: "locale_en_45asia_45pacific_46json_34dad782" */),
      cache: true
    }
  ],
  "ja-jp": [
    {
      key: "locale_ja_45jp_46json_9a272e56",
      load: () => import("#nuxt-i18n/9a272e56" /* webpackChunkName: "locale_ja_45jp_46json_9a272e56" */),
      cache: true
    }
  ],
  "zh-cn": [
    {
      key: "locale_zh_45cn_46json_6b961184",
      load: () => import("#nuxt-i18n/6b961184" /* webpackChunkName: "locale_zh_45cn_46json_6b961184" */),
      cache: true
    }
  ],
  "zh-tw": [
    {
      key: "locale_zh_45tw_46json_83ce26b9",
      load: () => import("#nuxt-i18n/83ce26b9" /* webpackChunkName: "locale_zh_45tw_46json_83ce26b9" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en-int",
    language: "en-int",
    _hreflang: "en-int",
    _sitemap: "en-int"
  },
  {
    code: "en-emea",
    language: "en-emea",
    _hreflang: "en-emea",
    _sitemap: "en-emea"
  },
  {
    code: "en-jp",
    language: "en-jp",
    _hreflang: "en-jp",
    _sitemap: "en-jp"
  },
  {
    code: "en-tw",
    language: "en-tw",
    _hreflang: "en-tw",
    _sitemap: "en-tw"
  },
  {
    code: "en-kr",
    language: "en-kr",
    _hreflang: "en-kr",
    _sitemap: "en-kr"
  },
  {
    code: "en-americas",
    language: "en-americas",
    _hreflang: "en-americas",
    _sitemap: "en-americas"
  },
  {
    code: "en-asia-pacific",
    language: "en-asia-pacific",
    _hreflang: "en-asia-pacific",
    _sitemap: "en-asia-pacific"
  },
  {
    code: "ja-jp",
    language: "ja-jp",
    _hreflang: "ja-jp",
    _sitemap: "ja-jp"
  },
  {
    code: "zh-cn",
    language: "zh-cn",
    _hreflang: "zh-cn",
    _sitemap: "zh-cn"
  },
  {
    code: "zh-tw",
    language: "zh-tw",
    _hreflang: "zh-tw",
    _sitemap: "zh-tw"
  }
]
/** client **/

/** client-end **/